import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import colors from "../../Constants/colors";
import { useTranslation } from "react-i18next";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

interface WorkspaceSelectorProps {
  workspaces: { id: number; name: string }[];
  workspaceId: string | number | null;
  setWorkspaceId: (id: string | number | null) => void;
  disabled?: boolean;
}

const WorkspaceSelector: React.FC<WorkspaceSelectorProps> = ({
  workspaces,
  workspaceId,
  setWorkspaceId,
  disabled = false,
}) => {
  const { t } = useTranslation("userPage");
  const { colors: workspace } = useWorkspaceColors();

  return (
    <Box sx={{ width: "100%", mt: 1, mb: 1 }}>
      <FormControl fullWidth size="small">
        <InputLabel
          shrink
          sx={{
            color: `${colors.gray600} !important`,
            fontSize: "0.875rem",
            backgroundColor: "white",
            px: 0.5,
            "&.Mui-focused": { color: `${workspace.primary_dark} !important` },
          }}
        >
          {t("workspace")}
        </InputLabel>
        <Select
          label={t("workspace")}
          name="workspace_id"
          value={workspaceId ?? ""}
          disabled={disabled}
          displayEmpty
          onChange={(e) => setWorkspaceId(e.target.value || null)}
          fullWidth
          sx={{
            bgcolor: "white",
            fontSize: "0.875rem",
            borderRadius: 2,
            color: `${colors.primary_dark} !important`,
            "& .MuiSelect-select": {
              color: `${colors.primary_dark} !important`,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.gray300,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: `0.5px solid ${workspace.primary_dark}`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `0.5px solid ${workspace.primary_dark}`,
              borderLeft: `4px solid ${workspace.primary_dark}`,
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                bgcolor: `${colors.white} !important`,
                border: `1px solid ${colors.gray200}`,
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                "& .MuiMenuItem-root": {
                  color: `${colors.primary_dark} !important`,
                  fontSize: "0.875rem",
                  "&:hover": {
                    backgroundColor: `${colors.gray50} !important`,
                  },
                  "&.Mui-selected": {
                    backgroundColor: `${workspace.primary_dark}0F !important`,
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: `${workspace.primary_dark}1A !important`,
                  },
                },
              },
            },
          }}
        >
          <MenuItem value="">
            <em style={{ color: colors.gray500, fontSize: "0.875rem" }}>
              {t("noWorkspace")}
            </em>
          </MenuItem>

          {workspaces.map((ws) => (
            <MenuItem key={ws.id} value={ws.id}>
              {ws.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default WorkspaceSelector;
